import React from 'react';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const SectionManagerForViewerWrapper_ViewerVersion1 = ({
  id,
  style,
  tellRef,
  className,
  children,
  onClick
})=> (
  <div
    ref={tellRef}
    id={id}
    className={className}
    style={style}
    onClick={onClick}
  >
    { children }
  </div>
);

const SectionManagerForViewerWrapper_ViewerVersion2 = ({
  id,
  style,
  tellRef,
  className,
  children,
  onClick
})=> (
  <section
    ref={tellRef}
    id={id}
    className={className}
    style={style}
    onClick={onClick}
  >
    { children }
  </section>
);

const SectionManagerForViewerWrapper = (props)=> (
  <SiteViewerVersionComponentSelector>
    <SectionManagerForViewerWrapper_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <SectionManagerForViewerWrapper_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default SectionManagerForViewerWrapper;
